import { render, staticRenderFns } from "./language-badge.vue?vue&type=template&id=0b51f141&"
import script from "./language-badge.vue?vue&type=script&lang=js&"
export * from "./language-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports